export const leaderboardSourceCatalog = [
  {
    game: "Valorant",
    source: "Riot Developer API",
    url: "https://developer.riotgames.com/",
    status: "needs_api_key",
    notes: "Use only official Riot API + approved endpoints. No scraping leaderboard pages.",
  },
  {
    game: "League of Legends",
    source: "Riot Developer API",
    url: "https://developer.riotgames.com/",
    status: "needs_api_key",
    notes: "Official Riot data only.",
  },
  {
    game: "Teamfight Tactics",
    source: "Riot Developer API",
    url: "https://developer.riotgames.com/",
    status: "needs_api_key",
    notes: "Official Riot data only.",
  },
  {
    game: "Dota 2",
    source: "OpenDota (public API)",
    url: "https://docs.opendota.com/",
    status: "ready",
    notes: "Public API; use tracked PR profiles list.",
  },
  {
    game: "Chess",
    source: "Chess.com Public API",
    url: "https://www.chess.com/news/view/published-data-api",
    status: "ready",
    notes: "Public profile/stats API; rank by rating for tracked PR accounts.",
  },
  {
    game: "CS2",
    source: "HLTV/Faceit official partnerships",
    url: "https://faceit.com/",
    status: "manual_or_partner",
    notes: "Avoid scraping HLTV/Faceit pages. Use partner API or manual verified imports.",
  },
  {
    game: "Rocket League",
    source: "Psyonix/Epic official data access",
    url: "https://www.rocketleague.com/",
    status: "manual_or_partner",
    notes: "No unofficial scraping. Use approved provider or manual CSV.",
  },
  {
    game: "Fortnite",
    source: "Epic official ecosystem",
    url: "https://dev.epicgames.com/",
    status: "manual_or_partner",
    notes: "No scraping stat sites. Use authorized Epic-compatible data flows only.",
  },
  {
    game: "Apex Legends",
    source: "EA/Respawn approved data sources",
    url: "https://www.ea.com/games/apex-legends",
    status: "manual_or_partner",
    notes: "Use approved data providers; avoid scraping unofficial trackers.",
  },
  {
    game: "Rainbow Six Siege",
    source: "Ubisoft official ecosystem",
    url: "https://www.ubisoft.com/",
    status: "manual_or_partner",
    notes: "Use official/partner access or manual verified uploads.",
  },
];
